import { render, staticRenderFns } from "./ManteCartaMesa.vue?vue&type=template&id=97f0060c&"
import script from "./ManteCartaMesa.vue?vue&type=script&lang=js&"
export * from "./ManteCartaMesa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports